<template>
  <div>
    <el-descriptions :column="2">
      <el-descriptions-item label="员工姓名">
        {{ detail.Dept }} {{ detail.User.Name }}
      </el-descriptions-item>
      <el-descriptions-item label="报告类型">
        {{ detail.Code }}
        {{ $utils.meta.format("report-type", detail.Type) }}
      </el-descriptions-item>
      <el-descriptions-item label="提交时间">
        {{ $utils.common.parseTime(detail.CreateTime, "{y}-{m}-{d} {h}:{i}") }}
      </el-descriptions-item>
      <el-descriptions-item label="工作时段">
        {{ $utils.common.parseTime(detail.FirstDate) }}
        至{{ $utils.common.parseTime(detail.LastDate) }}
      </el-descriptions-item>
      <el-descriptions-item label="工作内容" :span="2">
        <el-link v-for="item in schedules" :key="item.Id">
          {{ $utils.meta.format("schedule-type", item.text) }}
          {{ item.value }}次
        </el-link>
      </el-descriptions-item>
      <el-descriptions-item label="工作总结" :span="2">
        <span class="text-space">{{ detail.Content }}</span>
      </el-descriptions-item>
      <el-descriptions-item label="相关文件" :span="2" v-if="detail.Id">
        <uploader :data="{ Mode: 'job-report', ObjectId: detail.Id }" disabled :auto-upload="false" />
      </el-descriptions-item>
    </el-descriptions>
    <el-card shadow="never">
      <div slot="header" class="toolbar">
        <b>工作批示</b>
        <el-link type="primary" class="el-icon-edit" @click="onAppraise">工作批示</el-link>
      </div>
      <records type="Job-Report" :id="detail.Id" :key="detail.Id" style="padding: 0" />
    </el-card>
  </div>
</template>

<script>
export default {
  components: {
    uploader: () => import("@/views/system/file/multipleUpload"),
    records: () => import("@/views/system/record/list"),
  },
  props: {
    id: { type: String },
    layerid: { type: String },
  },
  data() {
    return {
      detail: {},
      schedules: [],
    };
  },
  created() {
    this.$apis.job.report.info({ id: this.id }).then((res) => {
      this.detail = res;
      return this.$apis.job.schedule.statis.type({
        state: 9,
        user: res.User.Id,
        timespan: [res.FirstDate, res.LastDate]
      })
    }).then(res => {
      this.schedules = res
      console.log(res)
    });
  },
  methods: {
    onAppraise() {
      this.$prompt(null, "工作批示", {
        center: true,
        inputType: "textarea",
        inputPlaceholder: "请输入批阅备注",
        inputPattern: /^.+$/,
        inputErrorMessage: "请输入批阅备注",
      }).then(({ value }) => {
        this.$apis.job.report
          .appraise({
            Id: this.detail.Id,
            Remark: value,
          })
          .then(() => {
            this.$parent.loadData();
            this.$layer.close(this.layerid);
            this.$message({ message: "保存成功！", type: "success" });
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-descriptions) {
  :not(.is-bordered) &-item__cell {
    padding-bottom: 30px;
  }
}
</style>